"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "buildUrl", {
  enumerable: !0,
  get: function a() {
    return _instafeedLite.buildUrl;
  }
}), exports.default = void 0;

var _instafeedLite = _interopRequireWildcard(require("instafeed-lite")),
    _default = _instafeedLite.default;

exports.default = _default;